<div class="settings-page w-full h-2/4 overflow-auto zuper-scrollbar bg-white scroll-smooth">
  <!-- header -->
  <div class="border-b border-gray-300 flex justify-between zuper-dialog-header">
    <div class="primary-font font-bold text-2xl text-gray-700 flex items-center pl-2">
      {{ "text.settings" | translate }}
    </div>
  </div>

  <!-- side navbar -->
  <div class="flex flex-wrap w-full overflow-auto zuper-scrollbar dialog">
    <div class="w-20 h-full bg-white border-r border-gray-300">
      <ul>
        <li title="{{'calendar.settings.calendar.title' | translate}}" class="">
          <button class="w-full border-b border-gray-300 border-solid h-20"
            [ngClass]="{ 'tab-icon-selected': moduleName === 'CALENDAR' }" (click)="onTabChange('CALENDAR')">
            <svg id="calendar" class="w-9 m-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
              fill="currentColor">
              <path fill-rule="evenodd"
                d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                clip-rule="evenodd" />
            </svg>
          </button>
        </li>
        <li title="{{'general.text' | translate}}" class="">
          <button class="w-full border-b border-gray-300 border-solid h-20"
            [ngClass]="{ 'tab-icon-selected': moduleName === 'GENERAL' }" (click)="onTabChange('GENERAL')">
            <svg width="24" class="w-9 m-auto" height="24" viewBox="0 0 24 24" fill="currentColor"
              xmlns="http://www.w3.org/2000/svg">

              <path fill-rule="evenodd"
                d="M3 3H11V11H3V3ZM13 3H21V11H13V3ZM3 13H11V21H3V13ZM16 13H18V16H21V18H18V21H16V18H13V16H16V13Z"
                clip-rule="evenodd" />

            </svg>
          </button>
        </li>
      </ul>
    </div>

    <!-- Content -->
    <div *ngIf="isLoading" class="flex items-center justify-center m-auto loader-div">
      <lazy-loader></lazy-loader>
    </div>
    <div class="settingsContent m-auto h-full overflow-auto zuper-scrollbar">
      <!-- CALENDAR -->
      <div [hidden]="moduleName !== 'CALENDAR'" *ngIf="!isLoading" class="py-4 px-2 mr-2 scrollHandler">
        <form [formGroup]="moduleFormMap?.calendar">
          <div class="border-b border-gray-300 flex justify-between pb-2">
            <span class="primary-font font-bold text-xl flex items-center">
              {{'dispatchBoard.settings.scheduler.job_card_info' | translate}}
            </span>
          </div>
          <div class="border-b border-gray-300 flex justify-between py-3">
            <div class="primary-font text-lg grid">
              <span class="leading-relaxed font-bold text-lg">
                {{'text.primary_color' | translate}} </span>
              <span class="font-normal text-lg">{{'dispatchBoard.settings.scheduler.primary_color_subtitle'
                | translate}}</span>
            </div>
            <div>
              <ng-select class="border-transparent w-40 cursor-pointer" formControlName="primary_color"
                [clearable]="false" [multiple]="false" [searchable]="false">
                <ng-option [value]="'jobCategory'">{{'job.category'
                  | translate}}</ng-option>
                <ng-option [value]="'jobPriority'">{{'text.job_priority'
                  | translate}}</ng-option>
                <ng-option [value]="'jobStatus'">{{'text.job_status'
                  | translate}}</ng-option>
                <ng-option [value]="'team'">{{'text.team'
                  | translate}}</ng-option>
              </ng-select>
            </div>
          </div>
          <div class="border-b border-gray-300 flex justify-between py-3">
            <div class="primary-font text-lg grid">
              <span class="leading-relaxed font-bold text-lg">
                {{'text.secondary_color' | translate}} </span>
              <span class="font-normal text-lg">{{'dispatchBoard.settings.scheduler.secondary_color_subtitle'
                | translate}}</span>
            </div>
            <div>
              <ng-select class="border-transparent w-40 cursor-pointer" formControlName="secondary_color"
                [clearable]="false" [multiple]="false" [searchable]="false">
                <ng-option [value]="'jobCategory'">{{'job.category'
                  | translate}}</ng-option>
                <ng-option [value]="'jobPriority'">{{'text.job_priority'
                  | translate}}</ng-option>
                <ng-option [value]="'jobStatus'">{{'text.job_status'
                  | translate}}</ng-option>
                <ng-option [value]="'team'">{{'text.team'
                  | translate}}</ng-option>
              </ng-select>

            </div>
          </div>
          <!-- Details -->
          <div class="pt-3">
            <span class="font-bold text-lg">{{'details' | translate}}
            </span>
            <p class="pt-1 font-normal text-lg">{{'text.choose_job_card.to_see' |
              translate}}
            </p>

            <div class="pt-3">
              <span class="leading-relaxed text-base font-semibold">{{
                "calendar.view.week_day"
                | translate
                }}</span>
              <!-- week and day Card view -->
              <app-calendar-settings-card *ngIf="isOptionsAvailable" [sectionType]="'weekday'" [module]="'CALENDAR'"
                [options]="{'MAX_ROW': 5, 'MAX_COLUMN': 2}">
              </app-calendar-settings-card>
            </div>

            <div class="pt-1">
              <span class="leading-relaxed text-base font-semibold">{{
                "month.view.label"
                | translate
                }}</span>
              <!-- month Card view -->
              <app-calendar-settings-card *ngIf="isOptionsAvailable" [sectionType]="'month'" [module]="'CALENDAR'"
                [options]="{'MAX_ROW': 1, 'MAX_COLUMN': 2}">
              </app-calendar-settings-card>
            </div>
          </div>
        </form>
      </div>
      <div [hidden]="moduleName !== 'GENERAL'" *ngIf="!isLoading" class="py-4 px-2 mr-2 scrollHandler">
        <form [formGroup]="moduleFormMap?.general">
          <!-- Display -->
          <div class="border-b border-gray-300 flex justify-between pb-2">
            <span class="primary-font font-bold text-xl flex items-center">
              {{'dispatchBoard.settings.scheduler.display_title' | translate}}
            </span>
          </div>
          <div formGroupName="display">
            <div class="border-b border-gray-300 flex justify-between pt-3">
              <p class="primary-font font-semibold text-xl flex items-center">
                {{'calendar.preferences' | translate}}
              </p>
            </div>
            <div class="border-b border-gray-300 flex justify-between py-3">
              <div class="primary-font text-lg grid">
                <span class="leading-relaxed font-bold text-lg">
                  {{'calendar.settings.startdate' | translate}} </span>
                <span class="font-normal text-lg">{{'calendar.days.details' | translate}}</span>
              </div>
              <div>
                <ng-select class="border-transparent w-40 cursor-pointer" formControlName="weekStartDay"
                  [clearable]="false" [multiple]="false" [searchable]="false">
                  <ng-option [value]="0">{{'calendar.days.sunday'
                    | translate}}</ng-option>
                  <ng-option [value]="1">{{'calendar.days.monday'
                    | translate}}</ng-option>
                  <ng-option [value]="2">{{'calendar.days.tuesday'
                    | translate}}</ng-option>
                  <ng-option [value]="3">{{'calendar.days.wednesday'
                    | translate}}</ng-option>
                  <ng-option [value]="4">{{'calendar.days.thursday'
                    | translate}}</ng-option>
                  <ng-option [value]="5">{{'calendar.days.friday'
                    | translate}}</ng-option>
                  <ng-option [value]="6">{{'calendar.days.saturday'
                    | translate}}</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="border-b border-gray-300 flex justify-between py-3">
              <div class="primary-font text-lg grid">
                <span class="leading-relaxed font-bold text-lg">
                  {{'calendar.default.view' | translate}} </span>
                <span class="font-normal text-lg">{{'calendar.view.details' | translate}}</span>
              </div>
              <div>
                <ng-select class="border-transparent w-40 cursor-pointer" formControlName="defaultCalendarView"
                  [clearable]="false" [multiple]="false" [searchable]="false">
                  <ng-option [value]="'day'">{{'calendar.view.day'
                    | translate}}</ng-option>
                  <ng-option [value]="'week'">{{'week.view.label'
                    | translate}}</ng-option>
                  <ng-option [value]="'month'">{{'month.view.label'
                    | translate}}</ng-option>
                </ng-select>
              </div>
            </div>

          </div>
          <div class="gap-3" formGroupName="display">
            <div class="flex items-center py-3 border-b border-gray-300">
              <input id="bussiness_hours_only" type="checkbox" formControlName="business_hours_only"
                class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600">
              <label for="bussiness_hours_only"
                class="cursor-pointer select-none">{{'calendar.display.business_hours_only'
                | translate}}</label>
            </div>
            <div class="flex items-center py-3 border-b border-gray-300">
              <input id="weekends" type="checkbox" formControlName="weekends"
                class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600">
              <label for="weekends" class="cursor-pointer select-none">{{'calendar.display.weekends'
                | translate}}</label>
            </div>

            <div class="flex items-center py-3 border-b border-gray-300">
              <input id="week_numbers" type="checkbox" formControlName="week_numbers"
                class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600">
              <label for="week_numbers" class="cursor-pointer select-none">{{'calendar.display.week_numbers'
                | translate}}</label>
            </div>
            <div class="flex items-center py-3 border-b border-gray-300">
              <input id="show_timeoff" type="checkbox" formControlName="show_timeoff"
                class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600">
              <label for="show_timeoff" class="cursor-pointer select-none">{{'calendar.display.timeoff'
                | translate}}</label>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- footer -->
  <div class="flex justify-end border-t border-gray-300 zuper-dialog-footer">
    <div class="flex justify-around space-x-4">
      <button type="button" (click)="closeSettingsDialog()"
        class="px-6 items-center py-2 border b-1 border-gray-300 bg-gray-100 text-black shadow-sm text-lg font-small rounded-md  bg-white focus:outline-none btn-small">
        {{'cancel.text' | translate}}</button>
      <button type="submit" [disabled]="disableSubmit()" (click)="onSubmit()"
        class="picker-choose-value-btn bg-primary px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-white font-small rounded-md text-white-600 focus:outline-none btn-small">{{'text.save' | translate}}</button>
    </div>
  </div>
</div>